// src/redux/account/accountSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchAccount } from "./accountThunk";
import { buildPermissions } from "./buildPermissions ";
const accountSlice = createSlice({
  name: "account",
  initialState: {
    data: null,
    loading: false,
    error: null,
    orgEntity: null,   // 👈 new state
    isAttendance: false,
    isOdometer: false,
    isLiveCamera: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAccount.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;

        state.orgEntity = action.payload?.orgInfo?.entities || null;

        state.isAttendance = action.payload?.orgInfo?.config?.attendance_option === "ENABLED";
        state.isOdometer = action.payload?.orgInfo?.config?.odometer === "ENABLED";
        state.isLiveCamera = action.payload?.orgInfo?.config?.liveCamera === "ENABLED";
      })
      .addCase(fetchAccount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default accountSlice.reducer;
